import { ObjectWithStringKeys } from '@/types';
import useGlobalTranslations    from '@/hooks/use-global-translations';
import { Breadcrumbs }          from '@/helpers/variables';

export const useBreadcrumbTranslations = (breadcrumbsNames: Breadcrumbs[]): ObjectWithStringKeys<string> => breadcrumbsNames
  .reduce((acc: ObjectWithStringKeys<string>, curr: string) => ({
    ...acc,
    [ curr ]: useGlobalTranslations(`breadcrumbs.${curr}`).toString(),
  }), {});
